/* @flow */

export const isRunning = (upload: RunningUpload) =>
  upload.state === 'processing' || upload.state === 'uploading';



// WEBPACK FOOTER //
// ./src/modules/bucket/reducers/upload.js